<template lang="pug">
  button.relative(
    :title="title"
    @click="toggle"
    v-if="visibleTab"
    :data-test="`tab-trigger--${tab}`"
  )
    span.name.block.uppercase.top-0(:class="{'name--active': activeTab, 'name--dark-mode': darkMode}") {{$t(tabName())}}
</template>

<script>
import { mapState } from 'redux-vuex';
import { prop } from 'ramda';
import { Icon } from '@/components/shared-components';

import { toggleTab } from '@/store/actions/tabs';

import store from '@/store';
import select from '@/store/selectors';

const availableTabs = ['chapters', 'files', 'info', 'transcripts', 'share', 'playlist', 'subscriptions', 'shownotes'];

export default {
  components: {
    Icon,
  },
  props: {
    tab: {
      type: String,
      default: null,
      validator: val => availableTabs.includes(val),
    },
    title: {
      type: String,
      default: '',
    },
    active: {
      type: String,
      default: () => 'inactive',
    },
  },
  data: mapState({
    tabs: select.tabs,
    color: select.theme.brandLightest,
    info: select.components.infoTab,
    chapters: select.components.chaptersTab,
    transcripts: select.components.transcriptTab,
    share: select.components.shareTab,
    files: select.components.filesTab,
    playlist: select.components.playlistTab,
    shownotes: select.components.shownotesTab,
    subscriptions: select.components.subscriptions,
    darkMode: select.customOptions.darkMode,
  }),
  computed: {
    activeTab() {
      return !!this.tabs[this.tab];
    },
    visibleTab() {
      return prop(this.tab, this);
    },
  },
  methods: {
    toggle() {
      store.dispatch(toggleTab(this.tab));
    },
    tabName() {
      return `${this.tab.toUpperCase()}.TITLE`;
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/assets/scss/media.scss';

.name {
  font-size: 12px;
  color: #000000;

  &--dark-mode {
    color: #FFFFFF;
  }

  &:hover, &--active {
    font-weight: bold;
  }
}
</style>
